import { Formik, Form, Field,ErrorMessage } from "formik";
import * as yup from 'yup';
import ResponsiveTabs from "../../../components/OB/Tabbar";
import { Box } from "@mui/material";
import { useState } from "react";
import BinaBasvuru from "./Bina-Basvuru";
import ArsaBasvuru from "./Arsa-Basvuru";
import AraziBasvuru from "./Arazi-Basvuru";
import IstekSikayetBasvuru from "./Istek-Sikayet-Basvuru";
import IstekSikayetTakip from "./istek-sikayet-takip";
import TcTelefonSmsControlPopup from "../../../components/OB/popups/tc-telefon-fogrulama-popup";
import  SessionStorageService from "../../../services/StorageService";

const IstekSikayet = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event:any, newValue:any) => {
    setValue(newValue);
  };
  const user=SessionStorageService.getUserInfo()
  const [smsControlled, setSmsControlled] = useState(user != null);
  const [tcKimlikNo, setTcKimlikNo] = useState("");
  const [cepTelefonu, setCepTelefonu] = useState("");
  return (
   <>
    {
      !smsControlled ? (
        <TcTelefonSmsControlPopup
          smsControlledSet={setSmsControlled}
          cepTelefonuSet={setCepTelefonu}
          tcKimlikNoSet={setTcKimlikNo}
        />
      ): <div>
        <ResponsiveTabs
          items={[
            { title: "İstek Şikayet Başvuru", onClick: () => console.log("Tab 1 clicked") },
            { title: "Başvuru Takip", onClick: () => console.log("Tab 2 clicked") },
            
          ]}
          value={value}
          onChange={handleChange}
          spreadWidth={false}
        />
        <Box className="pt-2">
          {value === 0 && <IstekSikayetBasvuru tcKimlikNo={tcKimlikNo}/>}
          {value === 1 && <IstekSikayetTakip tcKimlikNo={tcKimlikNo}/>}
        
        </Box>
      </div>
    }</>
  );
};

export default IstekSikayet;